/**
 * Get an environment variable from the import.meta.env or process.env object
 * to support both Vite and Node.js (Jest) environments.
 */
const getEnvironmentVariable = (key: string, defaultValue: string) => {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (import.meta.env) {
    return (
      (import.meta.env[key] as string | null) ??
      (import.meta.env[`VITE_${key}`] as string | null) ??
      defaultValue
    );
  }

  return process.env[key] ?? process.env[`VITE_${key}`] ?? defaultValue;
};

export const CONFIG = {
  /**
   * The current mode of the application.
   *
   * https://vitejs.dev/guide/env-and-mode
   */
  MODE: getEnvironmentVariable("MODE", "development"),
  /**
   * The URL of the login endpoint in the backend.
   */
  LOGIN_URL: getEnvironmentVariable(
    "LOGIN_URL",
    "http://localhost:8000/auth/login?redirect_after_auth=localhost_8000&dev=iwerkx",
  ),

  /**
   * The URL of the logout endpoint in the backend.
   */
  LOGOUT_URL: getEnvironmentVariable(
    "LOGOUT_URL",
    "http://localhost:3000/auth/logout?redirect_after_auth=localhost_8000&dev=iwerkx",
  ),
  /**
   * The URL of the GraphQL endpoint.
   */
  GRAPHQL_ENDPOINT: getEnvironmentVariable(
    "GRAPHQL_ENDPOINT",
    "http://localhost:8000/graphql",
  ),
  /**
   * The Sentry DSN.
   */
  SENTRY_DSN: getEnvironmentVariable("SENTRY_DSN", "missing"),
  /**
   * The mediamtx Api base URL.
   */
  MEDIAMTX_API_BASE_URL: getEnvironmentVariable(
    "MEDIAMTX_API_BASE_URL",
    "https://streaming.hub.prenode.de/api",
  ),
};
